import { DataTableScope } from '../../../shared/components/DataTable'
import { getDetailPanelPath } from '../../../shared/hooks/useTableDetailPanel'
import { StrategicImperative } from '../../../shared/queries/strategicImperatives'
import { StrategicImperativeColumnId } from './StrategicImperativeTable.types'

export const STRATEGIC_IMPERATIVES_TABLE_SCOPE: DataTableScope = { id: 'strategicImperativesTable', keptPer: 'roadmap' }

export const LINKED_ACTIVITIES_TABLE_SCOPE: DataTableScope = { id: 'strategicImperativeActivities', keptPer: 'roadmap' }

export const LINKED_VALUE_MESSAGES_TABLE_SCOPE: DataTableScope = {
    id: 'strategicImperativeValueMessages',
    keptPer: 'roadmap',
}

export const DEFAULT_LINKED_STRATEGIC_IMPERATIVE_COLUMN_IDS: ReadonlySet<StrategicImperativeColumnId> = new Set([
    'name',
])

export const getStrategicImperativePath = ({ _id }: StrategicImperative) =>
    getDetailPanelPath('/strategic-imperatives', _id)
